<template>
  <main class="main customer_main" role="main">
    <div class="main_con mb_pb">
      <div class="phone_pro_list">
        <ul class="phone_pro_list_ul" v-if="productList?.length > 0">
          <MobileProduct
            v-for="(item, index) in productList"
            :key="index"
            :item="item"
            :is-my-page="true"
            @view="goItemView"
            @goMobile="goMobile"
          />
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>찜한 휴대폰이 없습니다.<br /></div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'alert',
        msg: `최초 견적요청일로부터 일주일이 지나야만 재요청이 가능합니다.`,
      }"
      @close="popupClose"
    />
  </main>
</template>

<script>
import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import MobileProduct from '@/front/customer/views/home/components/MobileProduct.vue';

import format from 'date-fns/format';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  description: '찜한 인터넷 요금제',
  components: { MobileProduct, DesignPopup2 },
  data() {
    return {
      params: {
        page: 1,
        size: 100,
        selBookmark: 'Y', // 찜하기
      },
      productList: [],
      mobileCreateCheck: true,
      designPopup: false,
    };
  },
  computed: {
    ...mobileMapGetters({
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
    }),
  },
  async created() {
    await this.isMobileCreateCheck();

    this.getMobileProducts();
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING,
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_END,
      mobileTypes.SELECT_MOBILE_PRODUCTS,
      mobileTypes.UPDATE_MOBILE_VIEW_PRODUCT,
      mobileTypes.UPDATE_MOBILE_SEL_PRODUCT,
    ]),
    async getMobileProducts() {
      await this[mobileTypes.SELECT_MOBILE_PRODUCTS](this.params).then(res => {
        this.productList = res.content;
      });

      console.log('this.productList');
      console.log(this.productList);
    },
    goItemView(item) {
      localStorage.setItem('mobileProductSelect', JSON.stringify(item));
      this.$router.push({
        name: 'Mobile.ItemView',
        query: {
          isMobileCreate: this.mobileCreateCheck,
        },
      });
    },
    async isMobileCreateCheck() {
      let params = {
        callPart: 'CUSTOMER',
        status: 'ING',
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING](params);

      console.log('mobileRequestListIng');
      console.log(this.mobileRequestListIng);

      let paramsEnd = {
        callPart: 'CUSTOMER',
        status: 'END',
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_END](paramsEnd);

      console.log('mobileRequestListEnd');
      console.log(this.mobileRequestListEnd);

      // true = go create / false = popup
      let goCreateCheck = true;
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      // 휴대폰 견적을 생성한지 일주일이 지나야만 재요청이 가능하다 (최대 3건)
      if (this.mobileRequestListIng.content.length >= 3) {
        goCreateCheck = false;
      } else if (this.mobileRequestListIng.content.length == 2) {
        if (this.mobileRequestListEnd.content.length > 0) {
          const requestedAt = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays = format(
            new Date(requestedAt.setDate(requestedAt.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 안지났음
          if (now < sDays) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.mobileRequestListIng.content.length == 1) {
        if (this.mobileRequestListEnd.content.length > 1) {
          const requestedAt_1 = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays_1 = format(
            new Date(requestedAt_1.setDate(requestedAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_2 = new Date(
            this.mobileRequestListEnd.content[1].requestedAt,
          );

          const sDays_2 = format(
            new Date(requestedAt_2.setDate(requestedAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 둘다 안지남
          if (now < sDays_1 && now < sDays_2) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.mobileRequestListIng.content.length == 0) {
        if (this.mobileRequestListEnd.content.length > 2) {
          const requestedAt_1 = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays_1 = format(
            new Date(requestedAt_1.setDate(requestedAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_2 = new Date(
            this.mobileRequestListEnd.content[1].requestedAt,
          );

          const sDays_2 = format(
            new Date(requestedAt_2.setDate(requestedAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_3 = new Date(
            this.mobileRequestListEnd.content[2].requestedAt,
          );

          const sDays_3 = format(
            new Date(requestedAt_3.setDate(requestedAt_3.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 셋다 안지남
          if (now < sDays_1 && now < sDays_2 && now < sDays_3) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
      this.mobileCreateCheck = goCreateCheck;
    },
    goMobile(item) {
      if (this.mobileCreateCheck) {
        localStorage.setItem('myMobileModelName', item.modelName);
        this.$emit('setVisitPage');
        // 상품 견적 카운트 증가
        this.upSelProductCnt(item);

        this.$router.push({
          name: 'Mobile.Create',
          query: {
            mode: 'MY_MOBILE',
          },
        });
      } else {
        this.designPopup = true;
      }
    },
    upSelProductCnt(item) {
      const params = {
        modelId: item.modelId,
      };
      console.log('params :: {}', params);
      this[mobileTypes.UPDATE_MOBILE_SEL_PRODUCT](params);
    },
    popupClose() {
      this.designPopup = false;
    },
  },
};
</script>
